import api from '../../utils/api';
import { getRetailerSuppliers, getProductFilters, getProducts } from './api/retailers';
import { alertError } from './alert';

import {
  setProductFilters,
  setProductFiltersSetFilters,
  setProductFiltersOrder,
  setProductFiltersOrderField,
} from './productFilters';

import {
  REPLENISH_PRODUCTS,
  REPLENISH_PRODUCTS_COUNT,
  REPLENISH_PRODUCTS_SEARCH,
  REPLENISH_PRODUCTS_OFFSET,
  REPLENISH_BUY_PRODUCT,
  CLEAR_REPLENISH_BUY_PRODUCT,
  REPLENISH_PRODUCTS_LOADING,
  REPLENISH_PRODUCTS_SUPPLIER_ID,
  REPLENISH_PRODUCTS_BRANDS,
  REPLENISH_PRODUCTS_LOADING_PRODUCTS,
} from '../constants/replenishProducts';
import { getTotalCountHeader } from './api/utils';
import { ORDER_TYPE_REPLENISH } from '../../constants/orderTypes';

const setReplenishProductsLoading = (loadingProducts, value) => ({
  type: loadingProducts ? REPLENISH_PRODUCTS_LOADING_PRODUCTS : REPLENISH_PRODUCTS_LOADING,
  payload: value,
});

const setReplenishProducts = (data) => ({ type: REPLENISH_PRODUCTS, payload: data });
const setReplenishProductsCount = (count) => ({ type: REPLENISH_PRODUCTS_COUNT, payload: count });
export const setReplenishProductsBrands = (data) => ({ type: REPLENISH_PRODUCTS_BRANDS, payload: data });

export const setReplenishProductsSupplierId = (id) => (dispatch) => {
  dispatch(setReplenishProductsCurrentFilter({}));
  dispatch({ type: REPLENISH_PRODUCTS_SUPPLIER_ID, payload: id });
  dispatch(getReplenishProducts());
  dispatch(getReplenishProductsFilters());
};

export const getReplenishProductsBrands = () => async (dispatch, getState) => {
  const { retailerId, retailerSuppliers } = getState().role;

  dispatch(setReplenishProductsLoading(false, true));

  Promise.resolve()
    .then(() => {
      if (!retailerSuppliers || !retailerSuppliers.length) {
        return getRetailerSuppliers(retailerId).then((response) => (response ? response.data : retailerSuppliers));
      } else {
        return retailerSuppliers;
      }
    })
    .then((retailerBrands) => {
      dispatch(setReplenishProductsBrands(retailerBrands));
      dispatch(getReplenishProducts(true));
      dispatch(getReplenishProductsFilters());
      dispatch(setReplenishProductsLoading(false, false));
    });
};

export const getReplenishProducts =
  (loadingProducts = true) =>
  async (dispatch, getState) => {
    try {
      dispatch(setReplenishProductsLoading(loadingProducts, true));

      const state = getState();
      const { retailerId } = state.role;
      const { perPage, offset, count, search, supplierId } = state.replenishProducts;
      const { currentFilters, order, orderField } = state.productFilters;

      if (currentFilters.isRetailerApproved) {
        delete currentFilters.isRetailerApproved;
      }

      if (currentFilters.isApproved) {
        delete currentFilters.isApproved;
      }

      const response = await getProducts(
        retailerId,
        supplierId,
        'replenishment',
        currentFilters,
        offset,
        perPage,
        search,
        order,
        orderField,
      );

      const newCount = getTotalCountHeader(response);
      if (count !== newCount) {
        dispatch(setReplenishProductsCount(newCount));
      }

      dispatch(setReplenishProducts(response.data));
      dispatch(setReplenishProductsLoading(loadingProducts, false));
    } catch (error) {
      dispatch(alertError(error));
      dispatch(setReplenishProductsLoading(loadingProducts, false));
    }
  };

export const setReplenishProductsSearch = (search) => (dispatch) => {
  dispatch({ type: REPLENISH_PRODUCTS_SEARCH, payload: search });
  dispatch(setReplenishProductsOffset(0));
};

export const setReplenishProductsOrderField = (orderField) => (dispatch) => {
  dispatch(setProductFiltersOrderField(orderField));
  dispatch(getReplenishProducts());
};

export const setReplenishProductsOrder = (order) => (dispatch) => {
  dispatch(setProductFiltersOrder(order));
  dispatch(getReplenishProducts());
};

export const setReplenishProductsOffset = (offset) => (dispatch) => {
  dispatch({ type: REPLENISH_PRODUCTS_OFFSET, payload: offset });
  dispatch(getReplenishProducts());
};

export const buyProduct = (model) => (dispatch, getState) => {
  const state = getState();
  const { retailerId } = state.role;
  const { supplierId } = state.replenishProducts;

  dispatch({ type: CLEAR_REPLENISH_BUY_PRODUCT });

  model = encodeURIComponent(model);
  api
    .get(`/retailers/${retailerId}/suppliers/${supplierId}/products/${model}?service_type=${ORDER_TYPE_REPLENISH}`)
    .then((response) => {
      dispatch({ type: REPLENISH_BUY_PRODUCT, payload: response.data });
    });
};

export const getReplenishProductsFilters = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { retailerId } = state.role;
    const { supplierId } = state.replenishProducts;

    const response = await getProductFilters(retailerId, supplierId, ORDER_TYPE_REPLENISH);
    dispatch(setProductFilters(response.data));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const setReplenishProductsCurrentFilter = (filters) => (dispatch) => {
  dispatch(setProductFiltersSetFilters(filters));
  dispatch(setReplenishProductsOffset(0));
};
